module.exports = "<p class=\"menu-label is-hidden-touch\">DATA CENTER ACCESS</p>\n<ul class=\"menu-list\">\n  <li>\n    <a routerLink=\"request-list\" class=\"\">\n      <span class=\"icon\"><i class=\"fa fa-list\"></i></span> Request List\n    </a>\n  </li>\n  <li>\n    <a routerLink=\"request-form\" class=\"\">\n      <span class=\"icon\"><i class=\"fa fa-file-o\"></i></span> Create Request\n    </a>\n  </li>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/left-sidebar/left-sidebar.component.html
// module id = ../../../../../src/app/shared/components/left-sidebar/left-sidebar.component.html
// module chunks = main